<template>
  <div>
    <Row :gutter="20">
      <i-col :xs="12" :md="8" :lg="8" v-for="(infor, i) in inforCardData" :key="`infor-${i}`"
             style="height: 120px;padding-bottom: 10px;">
        <infor-card shadow :color="infor.color" :icon="infor.icon" :icon-size="36">
          <count-to :end="infor.count" count-class="count-style"/>
          <p>{{ infor.title }}</p>
        </infor-card>
      </i-col>
    </Row>
    <Row :gutter="20" style="margin-top: 10px;">
      <i-col :md="24" :lg="8" style="margin-bottom: 20px;">
        <Card shadow>
          <chart-pie style="height: 300px;" :value="pieData" text="账单来源" ref="charpie"></chart-pie>
        </Card>
      </i-col>
      <i-col :md="24" :lg="16" style="margin-bottom: 20px;">
        <Card shadow>
          <chart-bar style="height: 300px;" :value="barData" text="最近14天上传量"  ref="charbar"/>
        </Card>
      </i-col>
    </Row>
  </div>
</template>

<script>
import { InforCard } from '_c/info-card'
import CountTo from '_c/count-to'
import { ChartPie, ChartBar } from '_c/charts'
import Example from './example.vue'

export default {
  name: 'home',
  components: {
    InforCard,
    CountTo,
    ChartPie,
    ChartBar,
    Example
  },
  data () {
    return {
      inforCardData: [
        { title: '本月上传', icon: 'md-person-add', count: 0, color: '#2d8cf0' },
        { title: '新增金额（亿）', icon: 'md-locate', count: 0, color: '#19be6b' },
        { title: '累计上传', icon: 'md-help-circle', count: 0, color: '#ff9900' },
        { title: '累计金额（亿）', icon: 'md-share', count: 0, color: '#ed3f14' },
        { title: '累计用户', icon: 'md-chatbubbles', count: 0, color: '#E46CBB' },
        { title: '账户余额', icon: 'md-chatbubbles', count: 0, color: '#E46CBB' }
      ],
      pieData: [],
      barData: {}
    }
  },
  mounted () {
    let that = this
    this.G('tradestat/home').then(data => {
      that.pieData = []
      for (let i = 0; i < data.billList.length; i++) {
        let b = data.billList[i]
        that.pieData.push({ value: b.countData, name: b.billType })
      }
      this.$refs.charpie.updateData(that.pieData)
      that.inforCardData = [
        { title: '本月上传', icon: 'md-person-add', count: data.totalMap.monthCount, color: '#2d8cf0' },
        { title: '新增金额（亿）', icon: 'md-locate', count: data.totalMap.monthMoney, color: '#19be6b' },
        { title: '累计上传', icon: 'md-help-circle', count: data.totalMap.uploadCount, color: '#ff9900' },
        { title: '累计金额（亿）', icon: 'md-locate', count: data.totalMap.uploadMoney, color: '#ed3f14' },
        { title: '累计用户', icon: 'md-chatbubbles', count: data.totalMap.uploadUser, color: '#E46CBB' },
        { title: '账户余额', icon: 'md-document', count: data.totalMap.balance / 100, color: '#10C93FFF' }
      ]
      that.barData = {}
      for (let i = 0; i < data.lastDaysList.length; i++) {
        that.barData[data.lastDaysList[i].statTime] = data.lastDaysList[i].countData
      }
      this.$refs.charbar.updateData(that.barData)
    })

    this.$forceUpdate()
  }
}
</script>

<style lang="less">
.count-style {
  font-size: 30px;
}
</style>
